import React, { useState } from "react";
import Split from "react-split";
import DomTree from "../dom-tree/DomTree";
import PreviewPanel from "../preview-panel/PreviewPanel";
function TopPanel() {
  ///////-----SEARCH-------
  return (
    <Split
      sizes={[40, 60]}
      // minSize={100}
      // expandToMin={false}
      // gutterSize={10}
      // gutterAlign="center"
      // snapOffset={30}
      // dragInterval={1}
      // direction="horizontal"
      cursor="col-resize"
      className="flex h-full "
    >
      <DomTree />
      <PreviewPanel />
    </Split>
  );
}
export default TopPanel;
